import React from 'react';
import { NavLink } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';

import AppContext from '../../../components/AppContext';

import routes from './Routes';


interface NavLinkPanelToggleProps {
  href: string,
  children: React.ReactNode,
}

const NavLinkPanelToggle = (props: NavLinkPanelToggleProps) => {
  const setPanelContent = React.useContext(AppContext).setPanelContent;
  const resetPanel = () => setPanelContent(undefined);
  return (
    <NavLink to={props.href} className='nav-link' onClick={resetPanel}>
      {props.children}
    </NavLink>
  )
}

const Sidebar = () => (
  <Nav className='flex-column modus-sidebar'>
    {routes.map(( route, i ) => (
      route.icon
      ? (
        <Nav.Item key={i}>
          <NavLinkPanelToggle href={route.path}>
            <span className="left-nav-icon">
              {route.icon}
            </span>
            {route.breadcrumb}
          </NavLinkPanelToggle>
        </Nav.Item>
      )
      : null
    ))}
  </Nav>
);

export default Sidebar;
